export const initialValues = {
  personal: {
    first_name: '',
    nationality: '',
    last_name: '',
    national_id: '',
    date_of_birth: ''
  }
};
